// @ts-strict-ignore
import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { NavEntryPoint, NavItem } from '@retailer-platform/dashboard/routing'
import { shiftsRouter } from './routing/shiftsRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import ES_ES from './translations/es-ES.json'
import FR_FR from './translations/fr-FR.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import {
  shiftsAccessControl,
  csvHistoryAccessControl,
} from './access-control/shiftsAccess.configuration'
import { Permission } from './access-control/permissions'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'shifts',
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'shifts-dashboard-tool',
  },
  routes,
  translations: { EN_US, ES_ES, FR_FR },
  routers: {
    scoped: [shiftsRouter],
  },
  navigationEntries: [
    {
      attachTo: NavItem.Shoppers, //old nav group -- delete this navItem when `dashboard_store_ops_nav` feature toggle is fully enabled
      subNavItems: [
        {
          type: 'item',
          labelId: 'shiftsDomain.title',
          route: 'shifts',
          accessControl: shiftsAccessControl,
        },
      ],
    },
    {
      attachTo: NavItem.StoreOperations,
      attachToV2: NavEntryPoint.OperationsLabor,
      subNavItems: [
        {
          type: 'item',
          labelId: 'shiftsDomain.title',
          route: 'shifts',
          accessControl: shiftsAccessControl,
          id: 'nav-item-shifts',
          position: 2,
          positionNavV2: 2,
          inToolPermissions: [
            {
              slug: Permission.ShiftsModify,
              permissionLabelId: 'permissionAccordion.permissions.' + Permission.ShiftsModify,
            },
          ],
        },
        {
          type: 'item',
          labelId: 'shiftsDomain.csvHistory.title',
          route: 'csvHistory',
          accessControl: csvHistoryAccessControl,
          id: 'nav-item-csv-history',
          position: 3,
          positionNavV2: 3,
          inToolPermissions: [
            {
              slug: Permission.ShiftsModify,
              permissionLabelId: 'permissionAccordion.permissions.' + Permission.ShiftsModify,
            },
          ],
        },
      ],
    },
  ],
  adminNavigationEntries: [],
}

export default definition
